import { DeleteOutlined } from '@ant-design/icons'
import { Button, message, Popconfirm } from 'antd'
import React, { FunctionComponent, memo, useCallback } from 'react'

import { AuctionLinkedPropertyTableView } from '../../../common/auctionMonitoringTypes'
import { useDeleteAuctionPropertyMutation } from '../../../graphql/generated'

export interface AuctionMonitoringLinkedPropertyTableActionProps {
  id: string
  viewType: AuctionLinkedPropertyTableView
}

export const AuctionMonitoringLinkedPropertyTableAction: FunctionComponent<AuctionMonitoringLinkedPropertyTableActionProps> =
  memo(props => {
    const [, deleteProperty] = useDeleteAuctionPropertyMutation()

    const handleDelete = useCallback(() => {
      deleteProperty({ id: props.id })
        .then(() => {
          message.success('Nemovitost byla odstraněna.')
        })
        .catch(() => {
          message.error('Chyba při odstraňování nemovitosti.')
        })
    }, [deleteProperty, props.id])

    return (
      <Popconfirm
        okText="Odebrat"
        okType="danger"
        cancelText="Zpět"
        title="Opravdu chcete odebrat přiřazenou nemovitost?"
        placement="topRight"
        onConfirm={handleDelete}
      >
        <Button type="link" danger title="Odebrat přiřazení" size="small">
          {props.viewType === 'drawer' ? <DeleteOutlined /> : 'Odebrat'}
        </Button>
      </Popconfirm>
    )
  })
